export default __webpack_public_path__ + "static/char-s-52-zh-Hant-537e9de72b5a6fc076a3b84b6e5b5a4c.png";